import { AutoGraphRounded } from '@mui/icons-material'
import { Box } from '@mui/material'
import { MenuIcon } from 'genesis-suite/components'
import { useDispatch } from 'react-redux'
import { appearanceCreators, navigationCreators } from '../actions/creators'
import useHomeDashboard from '../hooks/useHomeDashboard'
import { routePaths } from '../lib/routes'
export default function GenerateSimulationButton({ iconStyle, buttonStyle }) {
    const { isError, isLoading } = useHomeDashboard()
    const dispatch = useDispatch()
    const closeSideNav = () => dispatch(appearanceCreators.closeSideNav())
    const goToManage = () => {
        closeSideNav()
        dispatch(navigationCreators.goTo(routePaths.AI_ANALYSIS))
    }
    if (isLoading && isError) return null
    return (
        <Box
            sx={theme => ({
                '& .MuiBadge-badge': {
                    right: '20%',
                    top: -3,
                    height: 12,
                },
            })}
        >
            <MenuIcon
                badge={'beta'}
                icon={<AutoGraphRounded sx={iconStyle} />}
                buttonProps={{ sx: buttonStyle }}
                tooltip="AI Analysis (beta)"
                noPadding
                onClick={goToManage}
            ></MenuIcon>
        </Box>
    )
}
